import { render } from "./Testimonial.vue?vue&type=template&id=577aac1d&scoped=true"
import script from "../js/testimonial.js?vue&type=script&lang=js"
export * from "../js/testimonial.js?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=577aac1d&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577aac1d"]])

export default __exports__